import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import WorkflowIcons from "@/components/Workflow/icons";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowStepIcon',
    props: {
        stepType: null
    },
    setup(__props) {
        const props = __props;
        const stepIcon = computed(() => {
            return WorkflowIcons[props.stepType];
        });
        return { __sfc: true, props, stepIcon, FontAwesomeIcon };
    }
});
